"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cachedApiRequest_1 = __importDefault(require("../cachedApiRequest"));
var defaultSettings = {
    element: '',
    endpoint: '',
    filterBy: 'title.rendered',
    itemTemplate: function (item) { return ("<li class=\"SuggestedSearch__item\">\n      <a href=\"javascript:;\">" + item + "</a>\n    </li>"); }
};
var isKeyboardEvent = function (e) { return e instanceof KeyboardEvent; };
var isFocusEvent = function (e) { return e instanceof FocusEvent; };
var highlightSuggestion = function (suggestion) { return suggestion.classList.add('highlight'); };
var objectByString = function (obj, str) { return (str.split('.').reduce(function (o, i) { return o[i]; }, obj)); };
var suggestedSearch = function (el, userSettings) {
    // Create the list element
    var list = document.createElement('ul');
    var settings = __assign(__assign({}, userSettings), { list: list, userSearch: '', data: [] });
    var showListContainer = function () { return settings.list.classList.remove('is-hidden'); };
    var hideListContainer = function () {
        settings.list.classList.add('is-hidden');
        settings.list.innerHTML = '';
    };
    var updateResults = function () {
        var userSearch = settings.userSearch, endpoint = settings.endpoint, filterBy = settings.filterBy, itemTemplate = settings.itemTemplate;
        var search = endpoint + '?search=' + userSearch;
        var _update = function (data) {
            if (!filterBy || !itemTemplate) {
                return;
            }
            settings.data = data;
            var searchTextClean = userSearch.toLowerCase();
            var searchWords = searchTextClean.split(' ');
            var filteredItems = data.filter(function (item) {
                var itemString = objectByString(item, filterBy);
                var itemValue = itemString.toLowerCase();
                return searchWords.every(function (word) { return itemValue.includes(word); });
            });
            var results = filteredItems.map(function (item) { return itemTemplate(item); });
            if (!results.length) {
                return hideListContainer();
            }
            settings.list.innerHTML = '';
            results.forEach(function (item) { return settings.list.innerHTML += item; });
            showListContainer();
        };
        // TODO: Examine dataset to determine if we need to refetch
        cachedApiRequest_1.default(search).then(_update);
        return true;
    };
    var incrementHighlightedItem = function (key, suggestions, activeItem, activeIndex) {
        var newIndex = key == 'ArrowUp' ? activeIndex-- : activeIndex++;
        activeItem.classList.remove('highlight');
        // Loop index
        if (newIndex >= suggestions.length) {
            newIndex = 0;
        }
        // Loop index
        if (newIndex < 0) {
            newIndex = suggestedSearch.length - 1;
        }
        suggestions[newIndex].classList.add('highlight');
    };
    var handleKeyboardEvents = function (e, suggestions, activeItem) {
        var key = e.key;
        switch (key) {
            case 'Tab':
            case 'ArrowUp':
            case 'ArrowDown':
                if (!activeItem) {
                    return highlightSuggestion(suggestions[0]);
                }
                var activeIndex = suggestions.indexOf(activeItem);
                return incrementHighlightedItem(key, suggestions, activeItem, activeIndex);
            case 'Esc':
                return hideListContainer();
            case 'Enter':
                if (!activeItem) {
                    activeItem = suggestions[0];
                }
                var link = activeItem.tagName === 'a' ? activeItem : activeItem.querySelector('a');
                if (link) {
                    return link.click();
                }
                return;
            default:
                return updateResults();
        }
    };
    var handleInputEvents = function (e) {
        e.preventDefault();
        var target = e.target;
        if (target.value.length < 4) {
            hideListContainer();
            return;
        }
        settings.userSearch = target.value;
        showListContainer();
        var suggestions = Array.from(settings.list.children);
        var activeItem = suggestions.length ?
            suggestions.filter(function (item) { return item.classList.contains('highlight'); })[0] : false;
        if (isKeyboardEvent(e)) {
            return handleKeyboardEvents(e, suggestions, activeItem);
        }
        if (isFocusEvent(e)) {
            return updateResults();
        }
    };
    // ---------------------------------------------------------------------------
    // Prepare the HTML
    settings.list.classList.add('SuggestedSearch__list', 'is-hidden');
    el.classList.add('SuggestedSearch');
    el.insertAdjacentElement('afterend', settings.list);
    el.addEventListener('keyup', handleInputEvents);
    el.addEventListener('focusin', handleInputEvents);
    // el.addEventListener('focusout', hideListContainer);
};
exports.default = (function (userSettings) {
    var settings = __assign(__assign({}, defaultSettings), userSettings);
    if (typeof settings.element === 'string') {
        settings.element = document.querySelector(settings.element);
    }
    return suggestedSearch(settings.element, settings);
});
